import { FC } from 'react';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../../../common/basic/QcsModalBox';
import { SectionHeader } from '../../../common/SectionHeader';
import * as Yup from 'yup';
import { Form } from 'formik';
import { FormikDebounce } from '../../../common/form/FormikDebounce';
import { FormContainer } from '../../../common/form/FormContainer';
import { validations } from '../../../../utils/validations';
import { SubmitButton } from '../../../common/form/SubmitButton';
import { WorkplaceAutocomplete } from '../../../common/form/WorkplaceAutocomplete';
import { invitationGetUpdateDto, useInvitation } from './invitationFunctions';
import { WorkplaceDto } from '@api/models/workplace/WorkplaceDto';
import { invitationService } from '@api/services/services';
import { resources } from '@api/resources';
import { ShowError } from '../../../ShowError';

interface WorkplaceAddModalForm {
  workplaces: WorkplaceDto[];
}

interface Props {
  open: boolean;
  onClose: () => void;
}

export const WorkplaceAddModal: FC<Props> = ({ open, onClose }) => {
  const { t, invitation, callWithLock, reloadInvitation } = useInvitation();

  const handleSubmit = async (data: WorkplaceAddModalForm) => {
    await callWithLock(async () => {
      const data2 = invitationGetUpdateDto(invitation);
      const data3 = {
        ...data2,
        workplaces: [
          ...data2.workplaces,
          ...data.workplaces?.map((x) => ({
            id: x.id!,
            name: x.name,
            nameEn: x.nameEn,
          })),
        ],
      };

      await invitationService.update(invitation.id!, data3);
      await reloadInvitation();

      onClose();
    });
  };

  return (
    <QcsModal open={open} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title="workplace.add" />
        <FormikDebounce<WorkplaceAddModalForm>
          initialValues={{
            workplaces: [],
          }}
          validationSchema={Yup.object().shape({
            workplaces: validations.arrayNotEmpty(t),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormContainer>
              <WorkplaceAutocomplete
                name="workplaces"
                label={t('invitation.workplace.name')}
                required
                excludeIds={invitation.workplaces?.map((x) => x.workplace?.id ?? '')}
                multiple
                showEstabilishmentName={true}
              />
              <ShowError resource={resources.updateInvitation} />
              <SubmitButton resourceLoading={resources.updateInvitation} />
            </FormContainer>
          </Form>
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
